export function parseMinutesToSeconds(seconds: string | undefined): string {
  if (!seconds) {
    return "0s";
  }

  let parsedSeconds = Number.parseFloat(seconds);

  if (Number.isNaN(seconds)) {
    return "0s";
  }

  return `${
    (parsedSeconds - (parsedSeconds %= 60)) / 60 +
    (parsedSeconds > 9 ? "m" : "m0") +
    parsedSeconds
  }s`;
}
